import Api from '@/api';
import { Http } from '../../../utilities/util';

const loadInspection = (context, folderId) => new Promise((resolve, reject) => {
  context.commit('setInspectionError', null);
  Api.folderService.getInspection(folderId)
    .then(response => {
      context.commit('setInspection', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setInspection', {});
      context.commit('setInspectionError', error);
      reject();
    });
});

const loadInspections = (context, customerId) => new Promise((resolve, reject) => {
  Api.customerService.getInspections(customerId)
    .then(response => {
      context.commit('setInspections', response.data);
      resolve(response.data);
    })
    .catch(error => {
      context.commit('setInspections', []);
      const err = Http.createError(error, 'inspection.actions.loadInspections', { customerId });
      Http.setGlobalError(context, err);
      reject();
    });
});

const setReportHasSummary = (context, reportId) => {
  context.commit('setReportHasSummary', reportId);
};

export default {
  loadInspection,
  loadInspections,
  setReportHasSummary,
};
